export default "__VITE_ASSET__D_vv0TIX__ 100w";